module.exports = __webpack_public_path__ + "img/banner.1cba04ca.png";